import { render, staticRenderFns } from "./_area.vue?vue&type=template&id=737b036b&scoped=true&"
import script from "./_area.vue?vue&type=script&lang=js&"
export * from "./_area.vue?vue&type=script&lang=js&"
import style0 from "./_area.vue?vue&type=style&index=0&id=737b036b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b036b",
  null
  
)

/* custom blocks */
import block0 from "./_area.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports